// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue             from 'vue'
import lodash          from 'lodash'
import moment          from 'moment'

import notLoggedApp    from './Not_Logged_App'
import adminApp        from './Admin_App'

import notLoggedRouter from './router/not_logged'
import adminRouter     from './router/admin'

import Loading from './components/Component_Loading'

import store from './store'

Vue.config.productionTip = false

import 'moment/locale/es'
moment.locale('es')

Vue.filter('twoDecimals', function (value) {
  return value.toFixed(2);
});

Vue.filter('formatDateHour', function (value) {
  return moment(value).format('DD/MM/yyyy HH:mm');
});

Vue.filter('truncateText', function (value, limit) {
  if (!value) return ''
  limit = limit || 50; // Si no se pasa un límite, se usa 50 por defecto
  const final = value.length > limit ? value.substring(0, limit) + '...' : value;
  return final
});

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('fromNow', function (value) {
  return moment(value).fromNow()
});

// Filtro para formatear la fecha como "24 de abril"
Vue.filter('customDate', function (value) {
  if (!value) return '';
  // Formatea la fecha con moment
  let formattedDate = moment(value).format('D [de] MMMM');

  // Capitaliza la primera letra del mes
  formattedDate = formattedDate.replace(/(?:de\s)(\w+)/, function (match, p1) {
    return 'de ' + p1.charAt(0).toUpperCase() + p1.slice(1).toLowerCase();
  });
  // Devuelve la fecha con el mes capitalizado
  return formattedDate;
});

Vue.component('loading', Loading)

// require('vue2-animate/dist/vue2-animate.min.css')

/* eslint-disable no-new */
var token = localStorage.getItem('token')

window._      = lodash
window.moment = moment

if (token) {
  new Vue({
    el: '#app',
    router: adminRouter,
    store,
    template: '<adminApp/>',
    components: { adminApp }
  })
} else {
  new Vue({
    el: '#app',
    router: notLoggedRouter,
    template: '<notLoggedApp/>',
    components: { notLoggedApp }
  })
}



// WEBPACK FOOTER //
// ./src/main.js